"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.imageStyleOptions = exports["default"] = exports.ImageStyleLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _reduxForm = require("redux-form");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _helpers = require("../../helpers.js");
var _InfoTooltip = _interopRequireDefault(require("../../components/InfoTooltip"));
var _ThumbnailManager = _interopRequireDefault(require("./ThumbnailManager"));
var _Course = _interopRequireDefault(require("./TypeFields/Course"));
var _Document = _interopRequireDefault(require("./TypeFields/Document"));
var _Link = _interopRequireDefault(require("./TypeFields/Link"));
var _Product = _interopRequireDefault(require("./TypeFields/Product"));
var _Video = _interopRequireDefault(require("./TypeFields/Video"));
var _Survey = _interopRequireDefault(require("./TypeFields/Survey"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var imageStyleOptions = exports.imageStyleOptions = [{
  label: 'Zoom in to cover available area',
  value: 'cover'
}, {
  label: 'Show full image in available area',
  value: 'contain'
}, {
  label: 'Limit size to appear as icon',
  value: 'icon'
}];
var ImageStyleLabel = exports.ImageStyleLabel = function ImageStyleLabel() {
  return /*#__PURE__*/_react["default"].createElement("span", null, "Image style", ' ', /*#__PURE__*/_react["default"].createElement(_InfoTooltip["default"], {
    tooltip: "Only applies when 'Show Thumbnail' and 'Cover Thumbnails' options are both enabled in Resource Center display options."
  }));
};
var fields = ['cost', 'courseCustomUrl', 'deploymentId', 'description', 'embed', 'imageStyle', 'fileUpload', 'internalName', 'isExternal', 'hasLicense', 'learnMore', 'link', 'publish', 'product', 'runtime', 'searchTerms', 'showCreditHours', 'moreInfoButtonTitle', 'moreInfoButtonContent', 'showCourseSectionHeaders', 'showMainIntroduction', 'showMoreInfoButton', 'tags', 'thumbnail', 'title', 'surveyInfo', 'questproject', 'showLanguage', 'useSurveyTitle', 'infoResource', 'duration', 'surveyType', 'audience', 'previewText', 'showConfirmation'];
var validate = exports.validate = function validate(values, props) {
  var errors = {};
  var type = props.type;
  if (!values.title) {
    errors.title = 'Name is required.';
  }
  if (!values.internalName) {
    errors.internalName = 'Internal Name is required.';
  } else {
    var regex = /^[a-zA-Z_$][\w$]+$/gm;
    if (values.internalName.length < 2) {
      errors.internalName = 'Internal Name must be at least 2 characters.';
    } else if (regex.test(values.internalName) === false) {
      errors.internalName = 'Internal Name cannot contain spaces, special characters or start with a number.';
    }
  }
  if (!values.tags || values.tags.length < 1) {
    errors.tags = 'Every resource must be tagged.';
  }
  if (type.handle === 'course') {
    if (!values.deploymentId) {
      errors.deploymentId = 'You must specify a Data Collection Wave.';
    }
    if (values.courseCustomUrl) {
      if (!(0, _helpers.isValidExternalLink)(values.courseCustomUrl) && !(0, _helpers.isValidInternalLink)(values.courseCustomUrl)) {
        errors.courseCustomUrl = 'Link URL is invalid.';
      }
    }
  }
  if (type.handle === 'document') {
    if (!values.fileUpload) {
      errors.fileUpload = 'You must upload a document file.';
    }
  }
  if (type.handle === 'link') {
    if (!values.link) {
      errors.link = 'Link URL is required.';
    } else if (!(0, _helpers.isValidExternalLink)(values.link)) {
      errors.link = 'Link URL is invalid.';
    }
  }
  if (type.handle === 'product') {
    if (!values.hasLicense && !(0, _helpers.isValidExternalLink)(values.link)) {
      errors.link = 'Link URL is invalid.';
    }
  }
  if (type.handle === 'video') {
    if (!values.embed) {
      errors.embed = 'Video Embed is required.';
    } else {
      var _regex = new RegExp('^(?:<iframe[^>]*)(?:(?:/>)|(?:>.*?</iframe>))$');
      if (_regex.test(values.embed) === false) {
        errors.embed = 'Embed iframe has errors. Please double check that you copied it correctly.';
      }
    }
    if (values.runtime) {
      // Regex for H:MM:SS string format
      var _regex2 = new RegExp('^[0-9]{1,2}:[0-5][0-9]:[0-5][0-9]$');
      if (_regex2.test(values.runtime) === false) {
        errors.runtime = 'Runtime in wrong format. E.x. 0:45:56 is 45 min and 56 seconds';
      }
    }
  }
  return errors;
};
var Form = /*#__PURE__*/function (_React$Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_this, "state", {
      tags: []
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.getTags();
    });
    _defineProperty(_this, "_getTagLabel", function (tag) {
      if (tag.internal_name && tag.name !== tag.internal_name) {
        return "".concat(tag.name, " (").concat(tag.internal_name, ")");
      }
      return tag.name;
    });
    _defineProperty(_this, "getTags", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _cccisdAxios["default"].get(Boilerplate.route('poly.api.v1.tag.index') + '?scope=resources.');
          case 2:
            response = _context.sent;
            _this.setState({
              tags: response.data
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    // Render proper form fields for the resource type
    _defineProperty(_this, "renderFieldsForType", function () {
      var _this$props$fields = _this.props.fields,
        cost = _this$props$fields.cost,
        courseCustomUrl = _this$props$fields.courseCustomUrl,
        deploymentId = _this$props$fields.deploymentId,
        surveyInfo = _this$props$fields.surveyInfo,
        questproject = _this$props$fields.questproject,
        embed = _this$props$fields.embed,
        fileUpload = _this$props$fields.fileUpload,
        isExternal = _this$props$fields.isExternal,
        hasLicense = _this$props$fields.hasLicense,
        learnMore = _this$props$fields.learnMore,
        link = _this$props$fields.link,
        product = _this$props$fields.product,
        runtime = _this$props$fields.runtime,
        showCreditHours = _this$props$fields.showCreditHours,
        showCourseSectionHeaders = _this$props$fields.showCourseSectionHeaders,
        showMainIntroduction = _this$props$fields.showMainIntroduction,
        showMoreInfoButton = _this$props$fields.showMoreInfoButton,
        moreInfoButtonTitle = _this$props$fields.moreInfoButtonTitle,
        moreInfoButtonContent = _this$props$fields.moreInfoButtonContent,
        showLanguage = _this$props$fields.showLanguage,
        useSurveyTitle = _this$props$fields.useSurveyTitle,
        infoResource = _this$props$fields.infoResource,
        duration = _this$props$fields.duration,
        surveyType = _this$props$fields.surveyType,
        audience = _this$props$fields.audience,
        previewText = _this$props$fields.previewText,
        showConfirmation = _this$props$fields.showConfirmation;
      switch (_this.props.type.handle) {
        case 'course':
          return /*#__PURE__*/_react["default"].createElement(_Course["default"], {
            courseCustomUrl: courseCustomUrl,
            deploymentId: deploymentId,
            showCreditHours: showCreditHours,
            showCourseSectionHeaders: showCourseSectionHeaders,
            showMainIntroduction: showMainIntroduction,
            showMoreInfoButton: showMoreInfoButton,
            moreInfoButtonTitle: moreInfoButtonTitle,
            moreInfoButtonContent: moreInfoButtonContent
          });
        case 'document':
          return /*#__PURE__*/_react["default"].createElement(_Document["default"], {
            fileUpload: fileUpload
          });
        case 'link':
          return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
            link: link
          });
        case 'product':
          return /*#__PURE__*/_react["default"].createElement(_Product["default"], {
            product: product,
            link: link,
            learnMore: learnMore,
            hasLicense: hasLicense,
            cost: cost,
            isExternal: isExternal
          });
        case 'survey':
          return /*#__PURE__*/_react["default"].createElement(_Survey["default"], {
            surveyInfo: surveyInfo,
            questproject: questproject,
            showLanguage: showLanguage,
            useSurveyTitle: useSurveyTitle,
            duration: duration,
            audience: audience,
            surveyType: surveyType,
            infoResource: infoResource,
            previewText: previewText,
            showConfirmation: showConfirmation
          });
        case 'video':
          return /*#__PURE__*/_react["default"].createElement(_Video["default"], {
            embed: embed,
            runtime: runtime
          });
        default:
          return null;
      }
    });
    // when 'Title' field blurs, copy contents to internalName and apply regex
    _defineProperty(_this, "onTitleBlur", function () {
      var _this$props$fields2 = _this.props.fields,
        title = _this$props$fields2.title,
        internalName = _this$props$fields2.internalName;
      if (internalName.value === '') {
        var r = title.value;
        r = r.replace(/^[^a-zA-Z0-9]*/gm, ''); // remove invalid leading characters
        r = r.replace(/[^\w$]/gm, '_'); // replace all other invalid characters with _
        internalName.onChange(r);
      }
    });
    return _this;
  }
  _inherits(Form, _React$Component);
  return _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props$fields3 = this.props.fields,
        description = _this$props$fields3.description,
        imageStyle = _this$props$fields3.imageStyle,
        internalName = _this$props$fields3.internalName,
        publish = _this$props$fields3.publish,
        searchTerms = _this$props$fields3.searchTerms,
        tags = _this$props$fields3.tags,
        thumbnail = _this$props$fields3.thumbnail,
        title = _this$props$fields3.title;
      var _this$props = this.props,
        editing = _this$props.editing,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        type = _this$props.type;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: title,
        label: "Title"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(title), {
        className: "form-control",
        onBlur: this.onTitleBlur
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: internalName,
        label: "Internal Name"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
        field: description,
        inputStyle: type.handle === 'course' ? {
          minHeight: '100px'
        } : {}
      })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TagInput, {
        field: tags,
        label: "Tags",
        data: this.state.tags.sort()
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: searchTerms,
        label: "Search Terms (comma-separated)"
      }, /*#__PURE__*/_react["default"].createElement("textarea", _extends({
        type: "text",
        className: "form-control",
        rows: "3"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(searchTerms)))), /*#__PURE__*/_react["default"].createElement(_ThumbnailManager["default"], {
        editing: editing,
        type: type,
        field: thumbnail
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: imageStyle,
        label: /*#__PURE__*/_react["default"].createElement(ImageStyleLabel, null)
      }, /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
        data: imageStyleOptions,
        onChange: function onChange(e) {
          return imageStyle.onChange(e.value);
        },
        textField: "label",
        value: imageStyle.value,
        valueField: "value"
      })), this.renderFieldsForType(), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, !this.props.hideBackButton && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        tabIndex: "-1",
        onClick: this.props.clearType
      }, "Back"), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        isLoading: submitting,
        onClick: handleSubmit
      }), !this.props.hidePublishToggle && /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        value: publish.value,
        onChange: publish.onChange,
        label: "Publish on save"
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  clearType: _propTypes["default"].func,
  editing: _propTypes["default"].bool,
  fields: _propTypes["default"].object,
  hideBackButton: _propTypes["default"].bool,
  hidePublishToggle: _propTypes["default"].bool,
  type: _propTypes["default"].object
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'TestForm',
  fields: fields,
  validate: validate
})(Form);